import React from 'react'

import Layout from 'components/Layout'
import SEO from 'components/SEO'
import styled from 'util/style'
import { Link } from 'components/Link'

const BlogPost = styled.div`
  width: 100%;
  margin-bottom: 60px;
  display: flex;
`

const BlogPostBanner = styled.div`
    display: block;
    flex: 1;
    padding-right: 40px;
`

const Author = styled.h2`
  font-weight: light;
  font-size: 18px;
  margin-bottom: 20px;
  color: #7cc1b7;
`

const BlogPostImage = styled.img`
    max-width: 100%;
    height: auto;
`;

const BlogPostContent =styled.div`
    flex: 3;
    padding: 20px 0;
`

const ReadMoreButton = styled.div`
  background: #000;
  text-transform: uppercase;
  color: #fff;
  padding: 6px 20px;
  text-align: center;
  display: inline-block;
  font-weight: bold;
  font-size: 12px;
`

const truncate = (input, maxLength = 300) => {
    if (!input || input.length - 3 <= maxLength) return input
    else return input.substring(0, maxLength - 3) + '...'
}

export function BlogPage({ data }) {

  return (
    <Layout>
      <SEO title="Blog" />

      {data && data.allPrismicBlogPost && data.allPrismicBlogPost.edges && data.allPrismicBlogPost.edges.map((edge) =>
        <BlogPost>
            <BlogPostBanner>
                {edge.node.data.banner_image.localFile &&
                    <Link to={'/blog/' + edge.node.uid}>
                        <BlogPostImage src={edge.node.data.banner_image.localFile.url} alt={edge.node.data.title.text} />
                    </Link>
                }
            </BlogPostBanner>
            <BlogPostContent>
                <h2>{edge.node.data.title.text}</h2>
                <Author>By {edge.node.data.authors}</Author>
                <p>{truncate(edge.node.data.content.text)}</p>
                <Link to={'/blog/' + edge.node.uid}>
                    <ReadMoreButton>Lees meer</ReadMoreButton>
                </Link>
            </BlogPostContent>
        </BlogPost>
    )}
    </Layout>
  )
}

export const query = graphql`
    query posts {
        allPrismicBlogPost(sort:{ fields: last_publication_date, order: DESC}) {
            edges {
                node {
                    id,
                    uid,
                    data {
                        authors,
                        title {
                            html
                            text
                        },
                        content {
                            html
                            text
                        },
                        banner_image {
                            localFile {
                                url
                            }
                        }
                    }
                }
            }
        }
    }
`

export default BlogPage
